import { Component } from '@angular/core';
import { Lightbox } from 'ngx-lightbox';
import { FilterStoreService } from 'src/app/services/filter-store.service';
import {
  ModalService,
  ObservableHandlerPair
} from 'src/app/services/modal.service';
import { PageIndexService } from 'src/app/services/page-index-service';
import { SignStickerPortalOverviewControllerRequestService } from './sign-sticker-portal-overview-controller-request.service';
import {
  AbstractSignsPortalAssociationOverviewComponent,
  SIGN_ASSOCIATION_TYPE
} from '../abstract-signs-portal-association-overview.component';
import { SignPortalAssociation } from '../sign-portal-association';
import { SignStickerControllerRequestService } from 'src/app/services/api/sign-associations/implementations/sign-sticker-controller-request.service';
import { SignStickerOverview } from 'src/app/model/sign/sticker/sign-sticker-overview';
import { SignStickerEditComponent } from '../../../sign-associations/edit-association/sign-sticker/sign-sticker-edit.component';
import { SignStickerDetail } from 'src/app/model/sign/sticker/sign-sticker-detail';

@Component({
  selector: 'sign-sticker-portal-overview',
  templateUrl: '../abstract-signs-portal-association-overview.component.html',
  styleUrls: ['../abstract-signs-portal-association-overview.component.scss']
})
export class SignStickerPortalOverviewComponent extends AbstractSignsPortalAssociationOverviewComponent<
  SignStickerDetail,
  SignStickerOverview
> {
  constructor(
    protected filterStoreService: FilterStoreService,
    protected pageIndexService: PageIndexService,
    protected signStickerPortalOverviewControllerRequestService: SignStickerPortalOverviewControllerRequestService,
    protected signStickerControllerRequestService: SignStickerControllerRequestService,
    protected modalService: ModalService,
    protected _lightbox: Lightbox
  ) {
    super(
      filterStoreService,
      pageIndexService,
      signStickerPortalOverviewControllerRequestService,
      signStickerControllerRequestService,
      modalService,
      _lightbox,
      SIGN_ASSOCIATION_TYPE.SIGN_STICKER
    );
  }

  protected getLocalStorageKey(): string {
    return 'SignStickerPortalOverviewComponent';
  }

  public editItem(item: SignPortalAssociation): void {
    this.modalService.openComponentInModal(
      SignStickerEditComponent,
      [
        { key: 'signId', value: item.sign.id },
        { key: 'assocObject', value: item }
      ],
      new ObservableHandlerPair(
        modalRef => modalRef.componentInstance.saveSuccessEvent,
        (res: SignStickerDetail) => {
          if (res != null) {
            this.doLoadSubject.next();
          }
        }
      ),
      { width: '750px', maxHeight: '90vh' }
    );
  }
}
